import { Flex, Stack } from '@mantine/core'
import { PropsWithChildren } from 'react'
import { IconType } from 'react-icons'

type LabeledContentProps = {
  label: string
  icon?: IconType
}

export const LabeledContent = ({
  label,
  icon: Icon,
  children,
}: PropsWithChildren<LabeledContentProps>) => {
  if (!children) return null

  return (
    <Stack gap={2}>
      <Flex align={'center'} gap={'xs'} fz="sm" c="dimmed" fw={700}>
        {Icon && <Icon size={'1.2em'} color="currentColor" />}
        {label}
      </Flex>
      {children}
    </Stack>
  )
}
